import React from "react";
import { Bar } from "react-chartjs-2";

const SprintPredictability = () => {

  const data = {
    labels:["Sprint1","Sprint2","Sprint3"],
    datasets:[
      {
        label:"Planned",
        data:[40,42,38],
        backgroundColor:"#06b6d4"
      },
      {
        label:"Delivered",
        data:[28,35,36],
        backgroundColor:"#22c55e"
      }
    ]
  };

  return (
    <div className="bg-gray-800 p-5 rounded-xl">
      <h3 className="text-white mb-4">🎯 Sprint Predictability</h3>
      <Bar data={data}/>
    </div>
  );
};

export default SprintPredictability;